// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 策划营销频道视频列表 GET /marketing-video/channel-video/list */
export async function marketingVideoChannelVideoListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.marketingVideoChannelVideoListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListMarketingVideoResp>('/marketing-video/channel-video/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 策划营销频道详情 GET /marketing-video/channel/info */
export async function marketingVideoChannelInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.marketingVideoChannelInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultMarketingChannelResp>('/marketing-video/channel/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 策划营销视频校验密码 POST /marketing-video/check-password */
export async function marketingVideoCheckPasswordUsingPOST(
  body: API.MarketingVideoCheckPasswordReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultboolean>('/marketing-video/check-password', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 策划营销视频详情 GET /marketing-video/video/info */
export async function marketingVideoVideoInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.marketingVideoVideoInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultMarketingVideoInfoResp>('/marketing-video/video/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
